// @flow

import axios      from 'axios';
import RoutesAPI  from './Routes';

let API_URL = '';
if( process.env.REACT_APP_API_URL ) {
  API_URL = process.env.REACT_APP_API_URL;
}

// Requests
const requests = {
  get: (url: string, body: any) => {
    return axios.get(API_URL + url, body);
  },
  getRaw: (url: string, body: any) => {
    return axios.get(window.URL_API_BASE + url, body);
  },
  s3post: (url: string, body: any) => {
    return axios.post(url, body);
  },
  post: (url: string, body: any) => {
    return axios.post(API_URL + url, body);
  }
};

const S3API = {
  getCreds: (file_name: string, file_key: string, file_ext: string, bucket: string) => {
    return requests.get(RoutesAPI.s3_creds_url() + '/' + file_name + file_key + file_ext + '?bucket=' + bucket, { bucket: bucket });
  },
  uploadFile: (bucket: string, data: any) => {
    return requests.s3post(RoutesAPI.s3_file_upload(bucket), data);
  },
  saveAttachment: (data: any) => {
    return requests.post(RoutesAPI.attachment_save(), data);
  },
  getFile: (hash: string) => {
    return requests.get(RoutesAPI.attachment_preview(hash), {});
  }
}

export default S3API;



// WEBPACK FOOTER //
// ./src/api/S3API.js